import React from 'react';
import CarouselGolden from './CarouselGolden';
import { Row, Col } from 'react-bootstrap';

function Dog({dog}) {

    const images = require.context('./img/golden/', true);
    const imageList = images.keys().filter(image => image.includes(dog.name)).map(image => images(image));

    return (
        <div className='container'>
            <h1 className='mb-3'>{dog.real_name}</h1>
            <Row>
                <Col>
                    {dog.info && 
                    <div>
                        {dog.info.map((info) => (
                            <div>{info}<br/></div>
                        ))}
                    </div>
                    }
                    {dog.info &&
                    <ul className='mt-3'>
                        {(dog.lien_ADN &&
                        <li>
                            <a href={dog.lien_ADN} target="_blank" rel="noopener noreferrer">
                                ADN de {dog.name}
                            </a>
                        </li>)}
                        {(dog.lien_HC &&
                        <li>
                            <a href={dog.lien_HC} target="_blank" rel="noopener noreferrer">
                                Hanches et coudes de {dog.name}
                            </a>
                        </li>)}
                        {(dog.lien_TO &&
                        <li>
                            <a href={dog.lien_TO} target="_blank" rel="noopener noreferrer">
                                Tares oculaires de {dog.name}
                            </a>
                        </li>)}
                    </ul>
                    }
                    <a href={dog.lien_pdf_pedigree} target="_blank" rel="noopener noreferrer">
                        Pedigree de {dog.name}
                    </a>
                    <p>
                        Retrouver son pedigree complet sur <a href={dog.lien_pedigree}>la centrale canine</a>
                    </p>
                </Col>
                <Col xs={12} sm={6}>
                    <CarouselGolden imageList={imageList} />
                </Col>
            </Row>
        </div>
    );

};

export default Dog;
